import { useRichTextEditorContext } from "@mantine/tiptap";

export const FontFamilySelect: React.FC = () => {
    const { editor } = useRichTextEditorContext();

    if (!editor) {
        return null;
    }

    return (
        <select
            onChange={(e) => {
                const value = e.target.value;
                if (value === "unset") {
                    editor?.chain().focus().unsetFontFamily().run();
                } else {
                    editor?.chain().focus().setFontFamily(value).run();
                }
            }}
            value={editor?.getAttributes("textStyle").fontFamily || "unset"}
            data-test-id="font-family-select"
            className="font-family-select text-sm xl:text-base"
        >
            <option value="Times New Roman">Times New Roman</option>
            <option value="Arial">Arial</option>
            <option value="unset">Open Sans</option>
            <option value="Carlito">Calibri</option>
        </select>
    );
};
